module.exports = __webpack_public_path__ + "ppm-icon.9484991da7934076d232.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/ppm-icon.svg
// module id = ../../../../../src/img/icon/ppm-icon.svg
// module chunks = styles